import * as React from "react";

export const HideShowPassword = (props:any) => <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M11.0625 7.73096C11.0625 9.14651 9.91445 10.2937 8.4989 10.2937C7.08335 10.2937 5.93616 9.14651 5.93616 7.73096C5.93616 6.3146 7.08335 5.1674 8.4989 5.1674C9.91445 5.1674 11.0625 6.3146 11.0625 7.73096Z" stroke={props.fill} strokeLinecap="round" strokeLinejoin="round"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M8.49772 13.6508C11.585 13.6508 14.4088 11.431 15.9987 7.73075C14.4088 4.03053 11.585 1.81073 8.49772 1.81073H8.50096C5.41366 1.81073 2.58986 4.03053 1 7.73075C2.58986 11.431 5.41366 13.6508 8.50096 13.6508H8.49772Z" stroke={props.fill} strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M1.81073 13.86L15.3137 0.999999" stroke={props.fill} strokeLinecap="round"/>
</svg>;



// WEBPACK FOOTER //
// ./src/images/HideShowPassword.tsx